import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, of, pairwise, startWith, Subscription } from 'rxjs';
import { AdminService } from 'src/app/modules/admin/services/admin.service';
import { IAPIResponse, IBuyerRC, ILineItemDetail, IPaginatedResult, Tab } from 'src/app/modules/shared/models';
import { IFormField } from 'src/app/modules/shared/models/form-field';
import { TabService } from 'src/app/modules/shared/services/tab.service';
import { PR_ACCOUNT_DETAILS_FORMFIELDS, PR_MATERIAL_MASTER_FORMFIELDS, PR_VENDOR_DETAILS_FORMFIELDS } from '../../../constants/pr-line-item-form-fields.constant';
import { IComponentInput, IMaterialCodeDetail, IVendorCodeDetail, LineItemTabType } from '../../../models';
import { PrInitiatorHelperService } from '../../../services/pr-initiator-helper.service';
import { LineItemFormComponent } from '../../line-item-form/line-item-form.component';
import { RcTableFormComponent } from '../../rc-table-form/rc-table-form.component';
import { PrInitiatorService } from '../../../services/pr-initiator.service';
export interface ILineItemTab {
  title : string, 
  tabType : LineItemTabType, 
  component : Type<any>, 
  componentInput : IComponentInput
}
@Component({
  selector: 'line-item-create',
  templateUrl: './line-item-create.component.html',
  styleUrls: ['./line-item-create.component.scss']
})
export class LineItemCreateComponent implements OnInit, OnDestroy {

  public title !: string;
  public onClose = new BehaviorSubject<any>({});
  @Input() purchaseRequestForm !: FormGroup;
  @Input() lineItemDetail !: any;
  @Input() rcList !: Array<IBuyerRC>;
  @Input() isMRPPr!: boolean;
  @Input() selectedAction ?: string;
  @Input() priceValue!:any;
  @Input() prUpdate?:any;
  @Input() selectedLineItemNumber?:any;
  @Input() withRC!:boolean;
  @Output() lineItemAdded : EventEmitter<any> = new EventEmitter();
  public isBalanceValid: boolean = true;

  // Tab related variables
  public _prTabList : Array<ILineItemTab> = [];
 
  public prTabs = new Array<Tab<IComponentInput>>();
  public activeTab : Tab<IComponentInput> | undefined;
  public isRCselected: boolean = false;
  public prFiles :any = [];
  // Subscriptions
  private _subscriptions : Array<Subscription> = [];
 
  
  constructor(
    private _helperService : PrInitiatorHelperService,
    private _adminService : AdminService,
    private tabService: TabService,
    public bsModalRef : BsModalRef,
    private _formBuilder : FormBuilder, 
    public _prInitiatorService: PrInitiatorService) {
      console.log("withRC", this.withRC)
     }

  ngOnInit(): void {
    
    console.log("withRCngOnInit", this.withRC, this.rcList)
    if(this.withRC){
      this._prTabList = [
        { title : "RC Processing", tabType : LineItemTabType.RC_PROCESSING, component : RcTableFormComponent, componentInput : {formFields : PR_VENDOR_DETAILS_FORMFIELDS, formGroup : this._helperService.getPRLineItemRCDetailForm(), rcList : this.rcList, isMRPPr : this.isMRPPr,rcLineItems:[],lineItemStatus:this.lineItemDetail?.line_item_status }},
      ];
      this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.RC_PROCESSING)].componentInput.rcList = this.rcList;
    } else{
      this._prTabList = [
        { title: "Material Master", tabType: LineItemTabType.MATERIAL_MASTER, component: LineItemFormComponent, componentInput: { formFields: PR_MATERIAL_MASTER_FORMFIELDS, formGroup: this._helperService.getPRLineItemMaterialMasterForm(), rcList: [], purchaseRequestForm: this.purchaseRequestForm, isMRPPr: this.isMRPPr,lineItemStatus:this.lineItemDetail?.line_item_status } },
        { title: "Account Details", tabType: LineItemTabType.ACCOUNT_DETAILS, component: LineItemFormComponent, componentInput: { formFields: PR_ACCOUNT_DETAILS_FORMFIELDS, formGroup: this._helperService.getPRLineItemAccountDetailForm(), rcList: [], tabName: "Account Details", isMRPPr: this.isMRPPr,lineItemStatus:this.lineItemDetail?.line_item_status,priceValue:this.lineItemDetail?.price } },
        { title: "Vendor Details", tabType: LineItemTabType.VENDOR_DETAILS, component: LineItemFormComponent, componentInput: { formFields: PR_VENDOR_DETAILS_FORMFIELDS, formGroup: this._helperService.getPRLineItemVendorDetailForm(), rcList: [], isMRPPr: this.isMRPPr,lineItemStatus:this.lineItemDetail?.line_item_status } },
        { title: "Attachments", tabType: LineItemTabType.ATTACHMENTS, component: LineItemFormComponent, componentInput: { formFields: [], formGroup:  this._formBuilder.group({}), rcList: [],tabName: "Attachments", isMRPPr: this.isMRPPr,prFiles:this.prFiles,lineItemStatus:this.lineItemDetail?.line_item_status } },
      ];
      this._prTabList[this._prTabList.findIndex(x=>x.tabType === LineItemTabType.MATERIAL_MASTER)].componentInput.formFields.forEach((x : IFormField) => {
        if(x.fieldName === 'currency' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getCurrency();
        if(x.fieldName === 'esn' && x.selectFields) {
          x.selectFields.apiAsync$ = this._adminService.getESNs();
          this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(this.lineItemDetail?.material_master?.esn);
        }
        if(x.fieldName === 'item_category' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getItemCategories();
        if(x.fieldName === 'ordering_unit' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getItemUnits();
        if(x.fieldName === 'service_category'&& x.selectFields) x.selectFields.apiAsync$ = this._prInitiatorService.getServiceMasterCategory();
      });
      this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.ACCOUNT_DETAILS)].componentInput.formFields.forEach((x: IFormField) => {
        if (x.fieldName === "acc_assignment_category" && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getAccountAssignmentCategories();
      })

      if (this.lineItemDetail) {
        this.patchLineItemDetailForm();
      }
      this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.MATERIAL_MASTER)].componentInput.purchaseRequestForm = this.purchaseRequestForm;
      this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.VENDOR_DETAILS)].componentInput.purchaseRequestForm = this.purchaseRequestForm;
    }
   
    this._prTabList.map((tab:ILineItemTab)=>{
      tab.componentInput.isMRPPr = this.isMRPPr;
    })
    
    this._prTabList[0].componentInput.formGroup.valueChanges.pipe(startWith(this._prTabList[0].componentInput.formGroup), pairwise()).subscribe(
      ([old, value]) => {
        if (!this.withRC && this.prTabs[0].tabData?.formGroup?.get('item_category')?.value) {
          this._prTabList[1].componentInput.itemCategory = this.prTabs[0].tabData?.formGroup?.get('item_category')?.value
        }
       
        this._prTabList[1].componentInput.info = { price: this.prTabs[0].tabData?.formGroup?.get('price')?.value }
      })
      
    
    this._prTabList.forEach(element => this.addNewTab(element)); 

    this._subscriptions.push(
      this.tabService.tabSubscription<IComponentInput>().subscribe(tabs => {
        this.prTabs = tabs;
      })
    );
  
    
    this.activeTab = this.prTabs[0];

    const accountDetailsForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.ACCOUNT_DETAILS)?.componentInput.formGroup;
    const materialMasterForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.MATERIAL_MASTER)?.componentInput.formGroup;
  
    if (accountDetailsForm) {
      accountDetailsForm.get('WBS_Balance_Value')?.valueChanges.subscribe(() => {
        this.validateBalance();
      });
    }
  
    if (materialMasterForm) {
      materialMasterForm.get('price')?.valueChanges.subscribe(() => {
        this.validateBalance();
      });
      materialMasterForm.get('acc_assignment_category')?.valueChanges.subscribe(() => {
        this.validateBalance();
      });
    }
    
  }

  private patchLineItemDetailForm() : void {
    this._prTabList.forEach(element => {
      if(element.tabType === LineItemTabType.ACCOUNT_DETAILS) {
        element.componentInput.formGroup.patchValue({ gl_account: this.lineItemDetail.gl_account,
         acc_assignment_category: this.lineItemDetail.acc_assignment_category,
         acc_assignment_value: this.lineItemDetail.acc_assignment_value,
         sales_order_no: this.lineItemDetail.sales_order_no,
         wbs_element: this.lineItemDetail.wbs_element,
         cost_center: this.lineItemDetail.cost_center });
      }
      if(element.tabType === LineItemTabType.MATERIAL_MASTER) {
        element.componentInput.formGroup.patchValue({ material_code: this.lineItemDetail.material_code ,
           item_category: this.lineItemDetail.item_category ,
           item_desc: this.lineItemDetail.item_desc ,
           short_text: this.lineItemDetail.short_text ,
           hsn_sac: this.lineItemDetail.hsn_sac ,
           po_text: this.lineItemDetail.po_text ,
           quantity: this.lineItemDetail.quantity ,
           currency: this.lineItemDetail.currency ,
           delivery_date: this.lineItemDetail.delivery_date ,
           esn: this.lineItemDetail.esn ,
           ordering_unit: this.lineItemDetail.ordering_unit ,
           matl_group: this.lineItemDetail.matl_group ,
           with_material: this.lineItemDetail.with_material ,
           warranties: this.lineItemDetail.warranties ,
           price: this.lineItemDetail.price});
      }
      if(element.tabType === LineItemTabType.VENDOR_DETAILS) {
        element.componentInput.formGroup.patchValue(
          { vendor_code: this.lineItemDetail.vendor_code,
            vendor_name: this.lineItemDetail.vendor_name,
            vendor_location: this.lineItemDetail.vendor_location}
        );
      }
      if(element.tabType === LineItemTabType.RC_PROCESSING) {
        if(this.lineItemDetail?.material_master) {
          element.componentInput.formGroup.controls["rcid"].patchValue(this.lineItemDetail?.material_master.rcid);
          element.componentInput.formGroup.controls["vendor_location"].patchValue(this.lineItemDetail?.vendor_details?.vendor_location);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.tabService.clearTabs();
    this._subscriptions.forEach(x=>x.unsubscribe());
  }

   /******** Tab action related methods **********/
   private addNewTab(tabItem : ILineItemTab) : void {
    // const componentName = tabItem.tabType === PRTabType.basic ? BasicDetailsComponent : RequestorDetailsComponent;
    const newTab = new Tab<IComponentInput>(tabItem.component, tabItem.title, tabItem.tabType, tabItem.componentInput);
    console.log(newTab,"NewTab")
    this.tabService.addTab<IComponentInput>(newTab);
  }

  public changeTab(tab : Tab<IComponentInput>) : void {
    this.activeTab = {...tab};
    this.tabService.updateTabStatus(tab.id - 1);
  }

  /** form valid */
  public isFormValid() : boolean {
    return this.prTabs.map(x=>x.tabData?.formGroup).every(y=>y?.valid == true);
  }

  public saveDetails() : void {
    const lineItemNumber = [];  
    if(!this.withRC){
      let attachments:any = []
    let lineItem : ILineItemDetail = { material_master : null, vendor_details : null, account_details : null, index : this.lineItemDetail?.index };
    for (let index = 0; index < this.prTabs.length; index++) {
      const element : Tab<IComponentInput> = this.prTabs[index];
      if(element.tabType === LineItemTabType.MATERIAL_MASTER) {
        console.log(lineItem, 'lineItem.material_master');
        lineItem.material_master = element.tabData?.formGroup.getRawValue();
        
        if(this.lineItemDetail?.material_master?.rcid && lineItem.material_master){
          lineItem.material_master.rcid = this.lineItemDetail.material_master.rcid
        } else if(lineItem.material_master) {
          lineItem.material_master.rcid = null
        }
        if(this.lineItemDetail && this.lineItemDetail.material_master?.material_master_id && lineItem.material_master) {
          lineItem.material_master.material_master_id = this.lineItemDetail.material_master?.material_master_id
        }
      }
      if(element.tabType === LineItemTabType.ACCOUNT_DETAILS) {
        lineItem.account_details = element.tabData?.formGroup.getRawValue();
        if(this.lineItemDetail && this.lineItemDetail.account_details?.account_details_id && lineItem.account_details) {
          lineItem.account_details.account_details_id = this.lineItemDetail.account_details?.account_details_id
        }
      }
      if(element.tabType === LineItemTabType.VENDOR_DETAILS) {
        lineItem.vendor_details = element.tabData?.formGroup.getRawValue();
        if(this.lineItemDetail && this.lineItemDetail.vendor_details?.vendor_details_id && lineItem.vendor_details) {
          lineItem.vendor_details.vendor_details_id = this.lineItemDetail.vendor_details?.vendor_details_id
        }
      }

      if(element.tabType === LineItemTabType.ATTACHMENTS && element.tabData?.prFiles?.length){
        //  element.tabData?.prFiles?.forEach((file:any)=>{
        //   const idx = lineItem.index?lineItem.index:0;
        //   attachments.push(new File([file], (idx+1)+"0_"+file.file.name, {type: file.file.type}));
        //  })
      }
      if(element.tabType === LineItemTabType.RC_PROCESSING) {
        const rcData = element.tabData?.formGroup.getRawValue();
        if(lineItem.material_master) {
          if(rcData.rcid) lineItem.material_master.rcid = rcData.rcid;
          if(rcData.material_code) lineItem.material_master.material_code = rcData.material_code
        }
        if(lineItem.vendor_details) {
          if(rcData.vendor_code) lineItem.vendor_details.vendor_code = rcData.vendor_code;
          if(rcData.vendor_location) lineItem.vendor_details.vendor_location = rcData.vendor_location;
          if(rcData.vendor_name) lineItem.vendor_details.vendor_name = rcData.vendor_name;
        }
      }
    }
    let line_Item = {...lineItem.account_details,...lineItem.material_master,...lineItem.vendor_details,...{index:lineItem.index}}
    let line_item_status = this.lineItemDetail?.line_item_status;
    if (line_item_status === "REJECTED") {
        line_item_status = "YET TO RELEASE";
    }

    if (!('line_item_status' in line_Item)) {
        line_Item = {
            ...line_Item,
            line_item_status: line_item_status,
            line_item_number: this.selectedLineItemNumber
        };
    } else {
        line_Item = {
            ...line_Item,
            line_item_status: line_item_status,
            line_item_number: this.selectedLineItemNumber
        };
    }
this.lineItemAdded.emit({ lineItem: line_Item, prFiles: this.prFiles });
    // this.closeModal(lineItem);
  }else{
    console.log(this._prTabList[0].componentInput.rcLineItems)
    this.closeModal(this._prTabList[0].componentInput.rcLineItems)
    this.lineItemAdded.emit(this._prTabList[0].componentInput.rcLineItems)
  }
  }


  /******** Method to be used to get data output from dynamically created component **********/
  public onTabDataUpdate(data : any) : void {
    console.log(data);
    // this.onClose.next(data);
  }

  /******** Method to be used for closing modal **********/
  public closeModal(data ?: ILineItemDetail) {
    // this.lineItemAdded.emit(null)
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public onModalClose() : void {
    this.lineItemAdded.emit()
    this.bsModalRef.hide()
  }

  detailByServiceCode(material_code: any) {
    this._prInitiatorService.detailByServiceCode(material_code).subscribe((res : IAPIResponse<any>) => {

      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].patchValue(res.data?.delivery_date);
      // this._prTabList[0].componentInput.formGroup.controls["price"].patchValue(res.data?.price);
      this._prTabList[0].componentInput.formGroup.controls["quantity"].patchValue(res.data?.quantity);
      this._prTabList[0].componentInput.formGroup.controls["short_text"].patchValue(res.data?.short_text);
      this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(res.data?.matl_group);
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].patchValue(res.data?.ordering_unit);
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].patchValue(res.data?.item_desc);

      this._prTabList[0].componentInput.formGroup.controls["currency"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].markAsTouched();
      // this._prTabList[0].componentInput.formGroup.controls["price"].markAsTouched();      this._prTabList[0].componentInput.formGroup.controls["quantity"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["short_text"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["esn"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].markAsTouched();
    }, err => {
      this._prTabList[0].componentInput.formGroup.controls["currency"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].patchValue(null);
      // this._prTabList[0].componentInput.formGroup.controls["price"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["quantity"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["short_text"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].patchValue(null);
    });
  }

  detailByMaterialCode(material_code: any, plant: any) {
    
    this._prInitiatorService.detailByMaterialCode(material_code, plant).subscribe((res : IAPIResponse<IMaterialCodeDetail>) => {
       
      this._prTabList[0].componentInput.formGroup.controls["currency"].patchValue(res.data?.currency);
      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].patchValue(res.data?.delivery_date);
      this._prTabList[0].componentInput.formGroup.controls["price"].patchValue(res.data?.price);
      this._prTabList[0].componentInput.formGroup.controls["quantity"].patchValue(res.data?.quantity);
      this._prTabList[0].componentInput.formGroup.controls["short_text"].patchValue(res.data?.short_text);
      this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(res.data?.matl_group);
      this._prTabList[0].componentInput.formGroup.controls["hsn_sac"].patchValue(res.data?.control_code);
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].patchValue(res.data?.ordering_unit);
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].patchValue(res.data?.item_desc);

      this._prTabList[0].componentInput.formGroup.controls["currency"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["item_category"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["price"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["quantity"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["short_text"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["esn"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].markAsTouched();
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].markAsTouched();
    }, err => {
      this._prTabList[0].componentInput.formGroup.controls["currency"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["delivery_date"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["item_category"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["price"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["quantity"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["short_text"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["ordering_unit"].patchValue(null);
      this._prTabList[0].componentInput.formGroup.controls["item_desc"].patchValue(null);
    });
  }

  validateBalance() {
    const accountDetailsForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.ACCOUNT_DETAILS)?.componentInput.formGroup;
    const materialMasterForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.MATERIAL_MASTER)?.componentInput.formGroup;
    if (accountDetailsForm && materialMasterForm) {
      const wbcBalanceValue = accountDetailsForm.get('WBS_Balance_Value')?.value;
      const wbcBalance = materialMasterForm.get('price')?.value;
      const acc_assignment_category = accountDetailsForm.get('acc_assignment_category')?.value;

      if(acc_assignment_category == 'P-Project'){
        console.log(acc_assignment_category, 'in validation !!@@');
        
        // this.isBalanceValid = Number(wbcBalanceValue) >= Number(wbcBalance);
        this.isBalanceValid = true;
      }else{
        this.isBalanceValid = true;
      }
    } else {
      this.isBalanceValid = true; 

    }
  }

}
function updateprice() {
  throw new Error('Function not implemented.');
}

